// Laravel paginate() returns:
// { data: [...], current_page, last_page, from, to, total, per_page, links }
// Our axios interceptor unwraps `{ status, data: <paginate> }` to just `<paginate>`,
// so the response we receive is the inner paginate object.

export function paginatedRows(response) {
  const inner = response?.data ?? response;
  if (!inner) return [];
  if (Array.isArray(inner)) return inner;
  if (Array.isArray(inner.data)) return inner.data;
  return [];
}

export function paginatedMeta(response) {
  const inner = response?.data ?? response;
  if (!inner || typeof inner !== "object" || Array.isArray(inner)) return null;
  if (typeof inner.current_page === "undefined") return null;
  return {
    current_page: inner.current_page,
    last_page: inner.last_page,
    from: inner.from,
    to: inner.to,
    total: inner.total,
    per_page: inner.per_page,
  };
}

export function unwrap(response) {
  return response?.data ?? response;
}
